import ListingsRoutingResolver from './ListingRoutingResolver';

class OpportunitiesListingResolver extends ListingsRoutingResolver {

    constructor() {
        super()
        this.key = "opportunity"
    }
}

export default OpportunitiesListingResolver
